"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FileMovieIcon = function FileMovieIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 256 256"
  }, props), _react.default.createElement("path", {
    d: "M244,0H12A12,12,0,0,0,0,12V244a12,12,0,0,0,12,12H244a12,12,0,0,0,12-12V12A12,12,0,0,0,244,0ZM102,24h52V48H102ZM24,24H78V48H24Zm0,48h92V184H24ZM78,232H24V208H78Zm76,0H102V208h52Zm78,0H178V208h54Zm0-48H140V72h92Zm0-136H178V24h54Z"
  }));
};

FileMovieIcon.displayName = 'FileMovieIcon';
FileMovieIcon.propTypes = {
  size: _propTypes.number
};
FileMovieIcon.defaultProps = {
  size: 40
};
var _default = FileMovieIcon;
exports.default = _default;